import { Link } from 'react-router-dom';
import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market,
} from '../market';

const GOOGLE_SEO_POISKOVIK_FAQ = [
  {
    title: 'Что такое поведенческие факторы (ПФ) и почему они важны?',
    isH3: true,
    text:
      <div>
        Поведенческие факторы (ПФ) — это действия пользователей на сайте, влияющие на восприятие ресурса поисковыми системами.
        <br />
        <br />
        К ним относятся:
        <br />
        <ul>
          <li>продолжительность сеанса,</li>
          <li>глубина просмотра,</li>
          <li>число возвращений,</li>
          <li>переходы по внутренним ссылкам.</li>
        </ul>
        <br />
        «Хорошие ПФ» могут способствовать повышению позиций сайта при прочих равных условиях.
      </div>
  },
  {
    title: 'Что значит «накрутка ПФ»?',
    isH3: true,
    text:
      <p>
        Под «накруткой ПФ» мы понимаем организованное взаимодействие аудитории с сайтом, включая:
        <br/>
        <br/>
        <ul>
          <li>переход по ключевым запросам,</li>
          <li>изучение контента,</li>
          <li>просмотр нескольких страниц,</li>
          <li>выполнение заданных действий и предоставления отчета теста</li>
        </ul>
        <br />
        Все действия выполняют реальные пользователи, не боты.
      </p>
  },
];

const GOOGLE_SEO_PROGREV_FAQ = [
  {
    title: 'Что такое «прогрев ссылок»?',
    isH3: true,
    text:
      <div>
        Это формат привлечения дополнительного трафика через переходы по внешним ссылкам с выполнением пользовательских действий на сайте.
        <br />
        <br />
        Инструмент используется для:
        <br />
        <ul>
          <li>тестирования воронки</li>
          <li>проверки юзабилити</li>
          <li>анализа кликабельности ссылок</li>
          <li>оценки поведения пользователей</li>
          <li>подготовки сайта к запуску рекламных кампаний</li>
        </ul>
      </div>
  },
  {
    title: 'Как работает формат «прогрев ссылок»?',
    isH3: true,
    text:
      <p>
        <ol>
          <li>Исполнитель получает страницу-источник.</li>
          <li>Переходит на сайт.</li>
          <li>Находит целевую ссылку.</li>
          <li>Переходит по ней.</li>
          <li>Выполняет действия по ТЗ.</li>
          <li>Отправляет отчёт.</li>
        </ol>
        <br />
        В результате клиент получает:
        <br />
        <ul>
          <li>реальный пользовательский путь</li>
          <li>переход по ссылке</li>
          <li>подтверждение выполнения сценария</li>
        </ul>
      </p>
  },
  {
    title: 'Это влияет на SEO?',
    isH3: false,
    text:
      <div>
        Инструмент не гарантирует изменений позиций. Поисковые системы не раскрывают алгоритмы ранжирования.
        <br />
        <br />
        Формат может использоваться для:
        <br />
        <ul>
          <li>проверки гипотез,</li>
          <li>тестирования страниц,</li>
          <li>анализа поведения пользователей.</li>
        </ul>
      </div>
  },
  {
    title: 'Можно ли использовать это вместо рекламы?',
    isH3: false,
    text:
      <div>
        Нет.
        <br />
        Инструмент не заменяет контекстную рекламу, SEO или работу с контентом.
        <br />
        Он может использоваться как дополнительный источник трафика или для тестирования.
      </div>
  },
  {
    title: 'Чем это отличается от накрутки?',
    isH3: false,
    text:
      <div>
        Исполнители проходят полный пользовательский путь по заданному сценарию и предоставляют отчёт о выполнении.
      </div>
  },
];

const STEP_TWO_TITLE_FAQ = <p>
  Почему при добавлении одного действия в калькуляторе появляются
  дополнительные действия?
  <br />
  <br />
  Сервис формирует уникальные сценарии для каждого исполнителя, и каждый
  сценарий начинается для нового исполнителя с поиска товара по сделанному
  скриншоту вашей ссылки.
</p>;

const INFO_POISKOVIK_ET = <p><b>Источник трафика: Выдача поисковика Google</b><br />Исполнитель найдет веб-сайт вручную с помощью поиска Google, затем выполнит задачи и отправит отчет.<br /> <Link to="/nakrutka-pf-google-progrev-ssylok">Изменить на Прогрев ссылок</Link></p>
const INFO_PROGREV_ET = <p><b>Источник трафика: Внешние ресурсы (Прогрев ссылок)</b><br />Размещение ссылки само по себе редко даёт результат — важны переходы по ним. Исполнители кликают по размещённым ссылкам и взаимодействуют с сайтом до 5 мин.<br /><Link to="/nakrutka-pf-google">Изменить на Трафик с поисковика</Link></p>

const POISKOVIK_ACTIONS = [
  { type: 'ALWAYS.OPEN', icon: 'open', iconHome: 'home-open', title: 'Открыть поисковик Google', initialShare: 1 },
  { type: 'ALWAYS.SEARCH', icon: 'search', iconHome: 'home-search', title: 'Набрать поисковый запрос', initialShare: 1 },
  { type: 'ALWAYS.COMPETITORS', icon: 'time', iconHome: 'home-time', title: 'Открыть несколько сайтов из ТОП-10', titleComment: 'не более 10 сек', initialShare: 1 },
  { type: 'ALWAYS.FIND', icon: 'search', iconHome: 'home-search', title: 'Найти сайт в поисковой выдаче Google', initialShare: 1 },
  { type: "ALWAYS.CLICK", icon: 'click', iconHome: 'home-click', title: "Зайти на продвигаемый сайт", initialShare: 1 },

  {
    type: 'EXTRA.DESCRIPTION',
    icon: 'glasses',
    iconHome: 'home-glasses',
    title: 'Изучить меню / каталог / услуги / товар',
    titleComment: 'от 3 мин',
    initialShare: 1,
    activityType: 'Изучение',
  },

  {
    type: 'MAIN.INFO',
    icon: 'search',
    iconHome: 'home-search',
    title: 'Почитать информацию о компании',
    initialShare: 1,
    activityType: 'Информация',
  },
  {
    type: 'MAIN.GEO',
    icon: 'people',
    iconHome: 'home-people',
    title: 'Зайти в адреса / контакты / карту',
    initialShare: 0,
    activityType: 'Контакты',
  },
  {
    type: 'MAIN.PHONE',
    icon: 'phone',
    iconHome: '',
    title: 'Копировать номер телефона с сайта',
    titleComment: 'без звонка',
    initialShare: 0,
    activityType: 'Телефон',
  },
  {
    type: 'MAIN.EMAIL',
    icon: 'message',
    iconHome: 'home-message',
    title: 'Копировать на сайте почту из контактов',
    initialShare: 0,
    activityType: 'Почта',
  },
];

const PROGREV_ACTIONS = [
  { type: 'ALWAYS.OPEN', icon: 'open', iconHome: 'home-open', title: 'Открыть сайт-донор по ссылке', initialShare: 1 },
  { type: 'ALWAYS.SEARCH', icon: 'search', iconHome: 'home-search', title: 'Найти ссылку на продвигаемый сайт', initialShare: 1 },
  { type: "ALWAYS.CLICK", icon: 'click', iconHome: 'home-click', title: "Зайти на продвигаемый сайт", initialShare: 1 },
  {
    type: 'EXTRA.DESCRIPTION',
    icon: 'glasses',
    iconHome: 'home-glasses',
    title: 'Изучить меню / каталог / услуги / товар',
    titleComment: 'от 3 мин на продвигаемом сайте',
    initialShare: 1,
    activityType: 'Изучение',
  },
  {
    type: 'MAIN.GEO',
    icon: 'people',
    iconHome: 'home-people',
    title: 'Зайти в адреса / контакты / карту',
    titleComment: 'на продвигаемом сайте',
    initialShare: 0,
    activityType: 'Контакты',
  },
  {
    type: 'MAIN.PHONE',
    icon: 'phone',
    iconHome: '',
    title: 'Копировать номер телефона с сайта',
    titleComment: 'без звонка на продвигаемом сайте',
    initialShare: 0,
    activityType: 'Телефон',
  },
  {
    type: 'MAIN.EMAIL',
    icon: 'message',
    iconHome: 'home-message',
    title: 'Копировать почту из контактов',
    titleComment: 'на продвигаемом сайте',
    initialShare: 0,
    activityType: 'Почта',
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-action",
    title: "Трафик с поисковика",
    path: "/nakrutka-pf-google",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
  {
    iconHome: "home-click",
    title: "Прогрев ссылок",
    path: "/nakrutka-pf-google-progrev-ssylok",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
  {
    iconHome: "home-open",
    title: "Открыть поисковик Google*",
    path: "/nakrutka-pf-google",
    target: '_self',
  },
  {
    iconHome: "home-pen",
    title: "Ввести поисковый запрос",
    path: "/nakrutka-pf-google",
    target: '_self',
  },
  {
    iconHome: "home-top",
    title: "Открыть несколько сайтов из ТОП-10",
    path: "/nakrutka-pf-google",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Найти сайт в поисковой выдаче Google*",
    path: "/nakrutka-pf-google",
    target: '_self',
  },
  {
    iconHome: "home-open",
    title: "Зайти на продвигаемый сайт",
    path: "/nakrutka-pf-google",
    target: '_self',
  },
  {
    iconHome: "home-glasses",
    title: "Изучить меню / каталог / услуги / товар",
    path: "/nakrutka-pf-google",
    target: '_self',
  },
  {
    iconHome: "home-map",
    title: "Контакты и адрес",
    path: "/nakrutka-pf-google",
    target: '_self',
  },
];

const STEP_PHRASE_2 = ' Укажите ключевые запросы и ссылку на сайт — и начните работу';
const STEP_PHRASE_2_PROGREV = ' Укажите ссылку на сайт-донор — и начните работу';

const GOOGLE_SEO_KEYWORDS = [
  'Google', 'google', 'Гугл', 'гугл'
];

const CHAIN_PRICE = 24;

class GoogleSeoClass extends Market {

  id = 'googleseo';

  host = 'google.ru';
  url = 'https://www.google.ru/';

  title = 'Google*';

  isMarketplace = false;
  isSeo = true;

  icon = "googleseo";
  titlePlaces = 'Google*';
  statusForHomePage = MARKET_MODE_STATUS.NEW;
  mainPageTitles = MAIN_PAGE_TITLES;

  chainsPerDayNormal = 42;

  chainPrice = CHAIN_PRICE;
  chainsMin = 20;
  chainsMax = 1000;

  chainsDefault = 20;

  reviewPrice = 250;

  chainsStep = 10;
  viewsStep = 10;

  keywords = GOOGLE_SEO_KEYWORDS;

  targetLinkComment = 'Укажите тут адрес вашего сайта';
  targetLinkCommentShort = 'Укажите сайт';

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      path: '/nakrutka-pf-google',
      rating: 0.01,
      title: 'Трафик с поисковика',
      navigateTitle: 'ПФ действия в поисковых системах',
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Накрутка ПФ ЛЮДИ в Google от ${CHAIN_PRICE} руб. — заказать поведенческие сценарии`,
        description: 'Накрутка ПФ ЛЮДИ в Google — поисковые переходы, просмотры, взаимодействия.',
        canonical: '/nakrutka-pf-google',
      },
      intro: {
        title: 'Накрутка ПФ Google* ↑',
        comment: 'Протестируйте продвижение в Google через поисковые ПФ сценарии от реальных пользователей',
        points: [
          'Помогает улучшить поведенческие факторы (ПФ)',
          'Способствует повышению позиций в Google*',
          'Повышает показатели вовлеченности и интереса к сайту',
          'Может оптимизировать расходы на рекламу',
        ]
      },
      howItWorks: [
        'Настройте параметры активности в соответствие с конкуренцией',
        'Укажите фразы для поиска вашего сайта',
        'Укажите город и прикрепите скриншот целевой страницы',
        'После оплаты мы передадим исполнителю скриншот и параметры для поиска',
        'Проверьте ответы и активность, примите работу или отправьте на доработку'
      ],
      stepPhrase1: 'Настройте параметры для управления пользовательскими сценариями',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      executorTypeInfo: INFO_POISKOVIK_ET,
      calculatorTitle: 'Продвижение в Google* через действия пользователей',
      titleFAQ: "Вопрос-ответ о накрутке поведенческих факторов в Google",
      faq: GOOGLE_SEO_POISKOVIK_FAQ,
      actions: (() => {
        return [
          ...POISKOVIK_ACTIONS.filter(action => action.type !== 'MAIN.REVIEW' && !action.type.startsWith('VIEW.')),
          ...POISKOVIK_ACTIONS.filter(action => action.type === 'MAIN.REVIEW'),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов',
        'Каждый исполнитель получит индивидуальное задание, что гарантирует разное поведение пользователей на вашем сайте',
        'Сложность цепочек и время исполнения зависит от их количества в проекте',
      ]
    },
    {
      id: MARKET_MODES.CHAINS,
      path: '/nakrutka-pf-google-progrev-ssylok',
      skipHostValidation: true,
      rating: 0.01,
      title: 'Прогрев ссылок',
      navigateTitle: 'ПФ действия в поисковых системах',
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Накрутка ПФ ЛЮДИ в Google от ${CHAIN_PRICE} руб. — заказать поведенческие сценарии`,
        description: 'Накрутка ПФ ЛЮДИ в Google — поисковые переходы, просмотры, взаимодействия.',
        canonical: '/nakrutka-pf-google-progrev-ssylok',
      },
      intro: {
        title: 'Накрутка ПФ Google* ↑',
        comment: 'Протестируйте продвижение в Google через поисковые ПФ сценарии от реальных пользователей',
        points: [
          'Помогает улучшить поведенческие факторы (ПФ)',
          'Способствует повышению позиций в Google',
          'Повышает показатели вовлеченности и интереса к сайту',
          'Может оптимизировать расходы на рекламу',
        ]
      },
      howItWorks: [
        'Настройте параметры активности в соответствие с конкуренцией',
        'Укажите фразы для поиска вашего сайта',
        'Укажите город и прикрепите скриншот целевой страницы',
        'После оплаты мы передадим исполнителю скриншот и параметры для поиска',
        'Проверьте ответы и активность, примите работу или отправьте на доработку'
      ],
      stepPhrase1: 'Настройте параметры для управления пользовательскими сценариями',
      stepPhrase2: STEP_PHRASE_2_PROGREV,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      executorTypeInfo: INFO_PROGREV_ET,
      calculatorTitle: 'Продвижение в Google через действия пользователей',
      titleFAQ: "Вопрос-ответ о накрутке поведенческих факторов в Google",
      faq: GOOGLE_SEO_PROGREV_FAQ,
      actions: (() => {
        return [
          ...PROGREV_ACTIONS.filter(action => action.type !== 'MAIN.REVIEW' && !action.type.startsWith('VIEW.')),
          ...PROGREV_ACTIONS.filter(action => action.type === 'MAIN.REVIEW'),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов',
        'Каждый исполнитель получит индивидуальное задание, что гарантирует разное поведение пользователей на вашем сайте',
        'Сложность цепочек и время исполнения зависит от их количества в проекте',
      ]
    },
  ];

  actionsMap = POISKOVIK_ACTIONS.reduce((map, action) => {
    map[action.type] = action; return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на сайт';
  invalidUrlStr = 'Укажите корректную ссылку на сайт';
}

const GoogleSeo = new GoogleSeoClass();
export default GoogleSeo;
